import { Box, CloseButton, ColorSwatch, Group, Indicator, Text, useMantineTheme } from "@mantine/core";

const { forwardRef } = require("react");

export const StatusSelectRenderer = forwardRef(({ image, label, color, description, ...others }, ref) => (
    <div ref={ref} {...others}>
        <Group noWrap>
            <Indicator position='middle-start' color={color}>
                <Text sx={{ paddingLeft: 12 }} size='sm'>
                    {label}
                </Text>
            </Indicator>
        </Group>
    </div>
));
export const StatusValue = ({ label, color, onRemove, ...others }) => {
    const theme = useMantineTheme();
    const isDark = theme.colorScheme === 'dark';

    return (
        <div {...others}>
            <Box
                sx={{
                    display: 'flex',
                    cursor: 'default',
                    alignItems: 'center',
                    backgroundColor: isDark ? theme.colors.dark[7] : theme.white,
                    border: `1px solid ${isDark ? theme.colors.dark[7] : theme.colors.gray[4]}`,
                    paddingLeft: theme.spacing.xs,
                    paddingRight: 2,
                    borderRadius: theme.radius.sm,
                }}>
                <Group spacing={6} noWrap sx={{ paddingRight: 4 }}>
                    <ColorSwatch size={10} color={theme.fn.themeColor(color ?? 'gray', 6)} withShadow={false} />
                    <Text size='xs' sx={{ lineHeight: 1 }}>
                        {label}
                    </Text>
                </Group>
                <CloseButton onMouseDown={onRemove} variant='transparent' size={22} iconSize={14} tabIndex={-1} />
            </Box>
        </div>
    );
};
